import React, { Component } from "react";
import $ from "jquery";
import { connect } from "react-redux";
import mapStateToProps from "../../../store/mapStateToProps";
import mapDispatchToProps from "../../../store/mapDispatchToProps";
import { hit } from "../../metrics";
import CaseFooter from "../CaseFooter";
import HelmetSite from "../HelmetSite";
import "./style.css";

class Pp extends Component {
  videoRef = React.createRef();

  state = {
    playing: false
  };

  componentDidMount() {

    if (this.props.pathname == '/projects/pp/') {
      this.props.setProjectName('Преображенская площадь');
      $('body').addClass('case-expanded hash-pp');
      $(window).scrollTop($('#case-pp').offset().top);
      this.props.changeCase(null);
    } else {
      $('body').removeClass('hash-pp');
    }
    window.scrollTo(0, 0);
    hit(window.location.pathname);
    setTimeout(() => {
      $('body').addClass('fadepage');
    }, 100);
  }

  componentDidUpdate() {
    if (this.props.pathname == '/projects/'){
      $('body').removeClass('case-expanded hash-pp');
    }

    if (this.state.playing) {
      if (this.videoRef.current) {
        this.videoRef.current.play();
        this.videoRef.current.onended = () => {
          this.setState({playing: false});
        };
      }
    }
  }
  
  componentWillUnmount() {
    $('body').removeClass('fadepage');
  }

  render() {
    
    return (<div className="case">
      <div className="case-content" id="case-pp">
        <div className="pp">
          <div className="screen screen0 h100">
            <div className="bg parallax-back">
              <div style={{backgroundImage: `url('/cases/img/pp/1.jpg')`}} />
            </div>
            <div className="pp-logo" />
          </div>
          <div className="screen screen1">
            <div className="bg parallax-back">
              <div style={{backgroundImage: `url('/cases/img/pp/4.jpg')`}} />
            </div>
            <svg className="letter" width="1275" height="648" viewBox="0 0 1275 648" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1029.65 29.6704C1224.58 29.6704 1368.06 394.159 730.841 341.269C741.987 168.172 881.245 29.6704 1029.65 29.6704ZM928.876 603.553C844.172 603.553 767.328 556.936 740.637 448.985C734.243 423.126 730.959 397.56 730.313 372.581H1233.79C1319.02 239.474 1281.3 0 1033 0C835.549 0 669.659 156.913 641.679 335.933C467.753 322.739 256.05 292.6 0 239.709C0.293299 247.215 1.75979 372.522 1.75979 372.522H637.924C636.399 404.069 639.215 436.026 647.075 467.632C675.877 584.203 781.289 648 907.583 648C1056.17 648 1195.02 579.277 1256.49 443.121L1200.41 429.635C1146.91 549.841 1038.8 603.553 928.876 603.553Z" className="fill" /></svg>
            <div className="content">
              <img className="screenshot screenshot1" src="/cases/img/pp/2.jpg" />
              <div className="text text1">
                <div className="bubble left parallax-front parallax-up">
                  <div className="in">
                    <p>Разрабатывая дизайн мы стремились передать динамику фирменного стиля, максимально показать движение вперёд, трансформацию, положительные изменения.</p>
                  </div>
                </div>
              </div>
              <div className="text text2">
                <div className="bubble left-bottom parallax-front parallax-up">
                  <div className="in">
                    <p>Помимо активной анимации, мы применяем небольшие видеофрагменты, которые выглядят ожившими фото.</p>
                  </div>
                </div>
              </div>
              <img className="screenshot screenshot2" src="/cases/img/pp/3.jpg" />
            </div>
          </div>
          <div className="screen screen2">
            <div className="bg parallax-back">
              <div style={{backgroundImage: `url('/cases/img/pp/9.jpg')`}} />
            </div>
            <svg className="letter" width="1680" height="540" viewBox="0 0 1680 540" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M147.05 4.22656C97.1703 4.22656 53.1546 35.8577 3.27533 94.9704C-32.8441 137.876 -74.749 201.138 -107.272 265.105H-107.976L-4.15182 4.22656H-43.164L-186 365.636H-145.502C-112.276 281.939 -42.9294 172.952 10.5461 108.985C52.4509 59.033 95.0594 24.5832 132.664 24.5832C175.976 24.5832 183.247 66.7842 148.535 155.336L66.1326 365.636H106.63L189.736 154.005C227.263 57.6237 210.689 4.22656 147.05 4.22656Z" className="fill" /><path d="M585.1 266.907C552.42 138.112 667.658 0 811.354 0C956.927 0 979.052 136.703 929.094 212.649H590.259C590.259 212.649 589.478 194.015 589.399 190.257C1014.31 241.227 928.156 16.9117 809.478 16.9117C704.95 16.9117 608.241 130.909 640.06 256.181C655.697 317.799 700.729 344.419 750.373 344.419C814.794 344.419 878.199 313.806 909.549 245.141L942.385 252.814C906.344 330.561 824.958 369.787 737.864 369.787C663.827 369.865 601.987 333.458 585.1 266.907Z" className="fill" /><path d="M325.146 76.6494L224.058 361.408C385.188 369.159 521.77 217.972 521.77 104.053C521.77 51.2818 492.139 27.4019 441.557 27.4019C402.466 27.4019 358.451 43.6089 325.146 76.6494ZM310.526 4.22656H351.023L328.116 66.7842C365.643 26.6972 422.715 4.22656 466.809 4.22656C531.152 4.22656 566.489 35.8577 566.489 94.8921C566.489 225.645 408.252 381.765 220.383 373.309L161.123 539.92H120.625L310.526 4.22656Z" className="fill" /><path d="M1298.11 118.46C1298.11 50.2655 1259.09 17.225 1209.21 17.225C1124.7 17.225 1030.02 117.756 1030.02 251.327C1030.02 318.817 1069.04 351.857 1119.62 351.857C1204.21 351.936 1298.11 252.11 1298.11 118.46ZM985.227 254.145C985.227 128.325 1100.86 0.391602 1224.38 0.391602C1295.92 0.391602 1343.61 45.4112 1343.61 115.72C1343.61 241.618 1227.98 369.552 1104.45 369.552C1032.92 369.474 985.227 324.533 985.227 254.145Z" className="fill" /><path d="M1700.42 118.459C1700.42 50.2642 1661.41 17.2237 1611.53 17.2237C1527.01 17.2237 1432.34 117.754 1432.34 251.326C1432.34 318.816 1471.35 351.856 1521.93 351.856C1606.52 351.934 1700.42 252.108 1700.42 118.459ZM1387.62 254.144C1387.62 128.246 1503.25 0.312012 1626.77 0.312012C1698.31 0.312012 1746 45.3316 1746 115.64C1746 241.539 1630.37 369.473 1506.84 369.473C1435.31 369.473 1387.62 324.531 1387.62 254.144Z" className="fill" /></svg>
            <div className="content">
              <div className="image image1">
                <img src="/cases/img/pp/5.jpg" />
                <div className="text text1 bubble left-bottom parallax-front parallax-up">
                  <div className="in">
                    <p>Сайт является продолжением и развитием фирменного стиля, он динамично и понятно предлагает информацию пользователю.</p>
                  </div>
                </div>
              </div>
              <img className="screenshot screenshot1" src="/cases/img/pp/6.jpg" />
              <img className="screenshot screenshot2" src="/cases/img/pp/7.jpg" />
              <img className="screenshot screenshot3" src="/cases/img/pp/8.jpg" />
            </div>
          </div>
          <div className="screen screen3">
            <svg className="letter" width="746" height="345" viewBox="0 0 746 345" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M212.724 2.7002C180.866 2.7002 152.752 22.909 120.893 60.6754C97.8232 88.0873 71.0579 128.505 50.2848 169.373H49.8354L116.149 2.7002H91.2317L0 233.601H25.8665C47.0889 180.127 91.3815 110.497 125.537 69.6293C152.303 37.7154 179.517 15.7059 203.536 15.7059C231.2 15.7059 235.844 42.6676 213.673 99.2422L161.041 233.601H186.908L239.989 98.3918C263.958 36.815 253.371 2.7002 212.724 2.7002Z" className="fill" /><path d="M492.514 170.524C471.641 88.2383 545.246 0 637.027 0C730.006 0 744.138 87.338 712.229 135.859H495.81C495.81 135.859 495.311 123.954 495.261 121.553C766.659 154.117 711.63 10.8047 635.829 10.8047C569.065 10.8047 507.295 83.6364 527.619 163.671C537.606 203.038 566.369 220.046 598.077 220.046C639.224 220.046 679.722 200.487 699.746 156.618L720.718 161.52C697.698 211.192 645.716 236.253 590.088 236.253C542.799 236.303 503.3 213.043 492.514 170.524Z" className="fill" /><path d="M326.478 48.9703L261.912 230.899C364.829 235.852 452.065 139.26 452.065 66.4779C452.065 32.7633 433.14 17.5066 400.832 17.5066C375.864 17.5066 347.751 27.8611 326.478 48.9703ZM317.14 2.7002H343.007L328.376 42.6676C352.345 17.0564 388.797 2.7002 416.961 2.7002C458.058 2.7002 480.628 22.909 480.628 60.6254C480.628 144.162 379.559 243.905 259.565 238.503L221.714 344.949H195.848L317.14 2.7002Z" className="fill" /></svg>
            <div className="content">
              <div className="video-display">
                <video playsInline muted pleload="none" ref={this.videoRef} poster="/cases/img/pp/video.jpg">
                  <source src="/upload/video-pp.mp4" type="video/mp4" />
                </video>
                {!this.state.playing && <div className="play" onClick={() => this.setState({playing: true})} />}
                <div className="text text1 bubble left-top parallax-front parallax-up">
                  <div className="in">
                    <p>Сочетание анимации и ярких видео-вставок выглядит интересно, и при всём при этом сайт получается не сложными, с ясным представлением информации.</p>
                  </div>
                </div>
              </div>
              <div className="screenshots">
                <div className="col">
                  <div className="text text2 bubble right parallax-front parallax-up">
                    <div className="in">
                      <p>Так выглядит сайт в смартфоне. Адаптация происходит под любое устройство.</p>
                    </div>
                  </div>
                  <img className="screenshot-mob screenshot4" src="/cases/img/pp/10.jpg" />
                </div>
                <div className="col">
                  <img className="screenshot-mob screenshot5" src="/cases/img/pp/11.jpg" />
                  <img className="screenshot-mob screenshot6" src="/cases/img/pp/12.jpg" />
                </div>
                <div className="col">
                  <img className="screenshot-mob screenshot7" src="/cases/img/pp/13.jpg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <CaseFooter 
				to= "/projects/soyuz/"
				title= { this.props.next ? this.props.next.name: "Союз"  } 
				img={ this.props.next ? this.props.next.imgCaseBottom:"/cases/img/next/soyuz_next.jpg"}
			/>
      <HelmetSite title={`Преображенская площадь`} />
    </div>)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Pp);
